import React from "react";
import InputRequire from "views/components/InputRequire";

export const NumberInput = ({
  id,
  label,
  value,
  onChange,
  placeholder = "0",
  errors = [],
  required = false,
  t,
}) => {
  return (
    <div
      className={errors.length ? "form-group row validated" : "form-group row"}
    >
      <label className="col-xl-3 col-lg-3 col-form-label" htmlFor={id}>
        {t(label)} {required && <InputRequire />}
      </label>
      <div className="col-lg-9 col-xl-6">
        <input
          id={id}
          type="number"
          className={errors.length ? "form-control is-invalid" : "form-control"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
        {errors.length > 0 &&
          errors.map((error, index) => (
            <div key={index} className="invalid-feedback">
              {error}
            </div>
          ))}
      </div>
    </div>
  );
};
